import * as Constants from "./constants";

export const getLocalStorageRegion = () => {
  const region = localStorage.getItem(Constants.regionLocalStorageKey) ?? undefined;
  return region;
};

export const getCurrentUrl = () => {
  const region = getLocalStorageRegion();
  const url = Constants.regionDataArray.find((el) => el.key === region)?.url;
  return url;
};

export const getQueryParams = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const paramsObj = {};
  params.forEach((value, key) => {
    paramsObj[key] = value;
  });
  return paramsObj;
};

export function deepCloning<T>(object: T): T {
  const clonedObject = JSON.parse(JSON.stringify(object)) as T;
  return clonedObject;
}
